<template>
  <!--
          作者：kmdshop
          时间：2019-10-24
          描述：后台系统头部
      -->
  <div class="common-header">
    <div class="breadcrumb">
      <!--一般的标题显示-->
      <div class="baseInfo-left-base d-s-c">
        <span class="name">{{ menu_title }}</span>
        <!--插件切换-->
        <div class="el-tabs-container">
          <el-tabs v-model="activeValue" @tab-click="tabClick">
            <el-tab-pane :label="item.value" :name="item.key" v-for="(item, index) in tabList" :key="index"></el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <div class="header-navbar">

        <div class="header-city-selector" @click="chooseCity">
        <span>{{ currentCity || '选择城市' }}</span>
        <i class="el-icon-arrow-down"></i>
      </div>


        <div class="header-navbar-icon">
          <span class="gray">当前版本：{{baseInfo.version.version}}</span>
        </div>
        <div class="header-navbar-icon">
          <span class="ml4"><Icon :iconname="'#icon-geren9'"></Icon></span>
          <span class="text ml4 blue">{{ baseInfo.user.user_name }}({{baseInfo.app_id}})，欢迎您！</span>
        </div>
        <div class="header-navbar-icon"><span class="gray">|</span></div>
        <div class="header-navbar-icon" @click="passwordFunc()"><span class="text">修改密码</span></div>
        <div class="header-navbar-icon" @click="routeFunc()"><span class="text">刷新</span></div>
        <a class="header-navbar-icon" v-if="baseInfo.version.show_help" :href=baseInfo.version.site_url target="_blank" ><span class="text">{{baseInfo.version.site_name}}</span></a>
        <div class="header-navbar-icon"><span class="gray">|</span></div>
        <div class="header-navbar-icon" @click="kefu" >
          <span  >在线客服 </span></div>
        
        <div class="header-navbar-icon login-out" @click="login_out()">
          <span><Icon :iconname="'#icon-tuichu'"></Icon></span>
          <span class="text ml4">退出</span>
        </div>
      </div>
    </div>

    <!--修改密码-->
    <UpdatePassword v-if="is_password" @close="closeFunc"></UpdatePassword>
<!--   :src="baseInfo.qr_icon" -->
    <div class="header-navbar-icon"  >
          <el-image
            style="width: 20px; height: 20px" ref="previewImg"
          
            :preview-src-list="srcList">
          </el-image>
        </div>

        <el-dialog 
    title="选择城市" 
    :visible.sync="cityDialogVisible" 
    width="30%"
    :close-on-click-modal="false"
    @change="confirmCity"
    
    >
    
    <!-- 新增的搜索框 -->
    <el-input
      v-model="citySearchQuery"
      placeholder="搜索城市"
      clearable
      style="margin-bottom: 10px;"
      @input="handleCitySearch">
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>

    <!-- 原有的城市选择框 -->
    <el-select 
      v-model="selectedCity" 
      placeholder="请选择城市"
      style="width: 100%"
       ref="citySelect"
      >
      <el-option
        v-for="item in filteredCityOptions"
        :key="item.cityCode"
        :label="item.cityName"
        :value="item.cityCode"
        >
      </el-option>
    </el-select>

    <span slot="footer" class="dialog-footer">
      <el-button @click="cityDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmCity">确定</el-button>
    </span>
</el-dialog>

    <div class="header-navbar-icon"  >
          <el-image
            style="width: 20px; height: 20px" ref="previewImg"
            :preview-src-list="srcList">
          </el-image>
        </div>
  </div>
</template>

<script>
import bus from '@/utils/eventBus.js';
import AuthApi from '@/api/auth.js';
import UserApi from '@/api/user.js';
import { setCookie, delCookie, getCookie, deleteSessionStorage } from '@/utils/base.js';
import router, { resetRouter} from '@/router';
import store from '@/store';
import eventBus from '@/utils/event-bus';
import voiceNotifier from '@/utils/voiceNotifier';
import { clearInterval, setInterval } from 'timers';

import UpdatePassword from './part/UpdatePassword.vue';
export default {
  components: {
    UpdatePassword
  },
  data() {
    return {
      /*菜单名称*/
      menu_title: '菜单',
      /*切换菜单*/
      tabList: [],
      /*切换选中*/
      activeValue: 0,
      /*是否修改密码*/
      is_password: false,
      /*tab切换类别*/
      tab_type:'',
      qr_code:this.baseInfo.qr_code,
      srcList:[this.baseInfo.qr_code],
      currentCity: '深圳市', // 当前选中的城市
      cityDialogVisible: false, // 城市选择对话框显示状态
      selectedCity: '', // 临时选中的城市
      cityOptions: [],
      role :'',
      pollInterval: null,
      lastNotifyTime: 0,
      notifyCount: 0,
      cityDialogVisible: false,
    selectedCity: '',
    cityOptions: [], // 原始城市数据
    citySearchQuery: '', // 搜索关键词
    filteredCityOptions: [], // 筛选后的城市数据
    };
  },
  inject: ['baseInfo'],
  created() {

    let userCity = localStorage.getItem('userCity');
    if(!userCity){
      const params = {}
      params.cityName = '深圳市'
      params.cityCode = "440300000000"
      localStorage.setItem('userCity', JSON.stringify(params));
    }

    /*监听菜单传过来的值*/
    bus.$on('menuName', res => {
      this.menu_title = res;
    });

    /*监听传插件的值*/
    bus.$on('tabData', res => {
      this.tabList = res.list;
      this.activeValue = res.active;
      this.tab_type=res.tab_type;
    });

       //发送给其它组件头部加载完成
       bus.$emit('headLoad', true);
  },
  beforeDestroy() {
    bus.$off('menuName');
    bus.$off('tabData');
    this.stopPolling();
  },
  mounted() {
    this.filteredCityOptions = this.cityOptions;
    let userCity = localStorage.getItem('userCity');
    if(!userCity){
      const params = {}
      params.cityName = '深圳市'
      params.cityCode = "440300000000"
      localStorage.setItem('userCity', JSON.stringify(params));
    }
    const savedCity = localStorage.getItem('selectedCity');
    if (savedCity) {
      this.currentCity = savedCity;
    }
    let userInfo =  JSON.parse(localStorage.getItem('uinfo'))
    this.role = userInfo.data.role
    if(this.role ==='store'){
      this.startPolling()
    }
  },
  methods: {
    startPolling() {
      // 每10秒检查一次新订单
      this.pollInterval = setInterval(() => {
        this.checkNewOrders();
      }, 10000);
    },
    handleCitySearch() {
    if (!this.citySearchQuery) {
      this.filteredCityOptions = this.cityOptions;
    } else {
      const query = this.citySearchQuery.toLowerCase();
      this.filteredCityOptions = this.cityOptions.filter(item =>
        item.cityName.toLowerCase().includes(query)
      );
    }
    this.$nextTick(() => {
      const selectEl = this.$refs.citySelect.$el;
      const inputEl = selectEl.querySelector('.el-input__inner');
  if (inputEl) inputEl.click(); 
});
  },
    
    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
    },
    
    async checkNewOrders() {
      try {
        await AuthApi.getNewOrders().then(res => {
          this.handleNewOrders(res.data);
        })
      } catch (error) {
        console.error('获取新订单失败:', error);
      }
    },
    
    handleNewOrders(orders) {
      const now = Date.now();
      
      // 同一时间只播放最多3次
      if (now - this.lastNotifyTime < 5000 && this.notifyCount >= 3) {
        return;
      }
      
      // 重置计数
      if (now - this.lastNotifyTime >= 5000) {
        this.notifyCount = 0;
      }
      
      // 播放语音通知
      orders.forEach(order => {
        if (this.notifyCount < 3) {
          voiceNotifier.play(`你有一条新订单，待处理`);
          this.notifyCount++;
          this.lastNotifyTime = now;
        }
      });
    },
     // 打开城市选择对话框
      chooseCity() {
      this.cityDialogVisible = true;
       UserApi.getCity().then((res)=>{
        this.cityOptions = res.data
      })
       
      const currentOption = this.cityOptions.find(item => item.cityName === this.currentCity);
      this.selectedCity = currentOption ? currentOption.value : '';
    },
    // 确认选择的城市
    confirmCity() {  
    const selectedOption = this.cityOptions.find(item => item.cityCode === this.selectedCity);
    localStorage.setItem('userCity', JSON.stringify(selectedOption));

    this.currentCity = selectedOption ? selectedOption.cityName : '';
    this.cityDialogVisible = false;
    localStorage.setItem('selectedCity', this.currentCity);

    eventBus.$emit('city-changed', this.currentCity);
    this.$message({
      message: `已切换至${this.currentCity}`,
      type: 'success'
    });

    
  },
    kefu(){
      var self = this;
      var temp = [self.baseInfo.qr_code]
      if(self.srcList[0].length <= 0){
        self.srcList = temp
      } 
      console.log(self.srcList)
      if(self.srcList.length > 0){
        self.$refs.previewImg.showViewer = true;
      }else{
        self.kefu()
      }
      
      
    
      //this.qr_code_sta = true;
      // var list = [img];
      // this.srcList  = list;
    },
    getNewOrder(){
      if(this.role === 'store'){

      }
    },
    /*退出登录*/
    login_out() {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          UserApi.loginOut({}, true)
            .then(data => {
              /*删除登录状态*/
              delCookie('isLogin');
              delCookie('token');
              /*删除基本信息*/
              delCookie('baseInfo');
              /*删除用户菜单*/
              deleteSessionStorage('rolelist');
              /*删除用户权限*/
              deleteSessionStorage('authlist');
              /*返回登录页*/
              this.$router.replace({ path: '/login' });
              /*删除stores数据*/
              this.$store.commit('user/setState', { key: 'roles', val: null });
              /*刷新页面*/
              location.reload();
            })
            .catch(error => {});
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消退出'
          // });
        });
    },

    /*点击跳转*/
    tabClick(e) {
      /*分销*/
      if(this.tab_type=='agent'){
        this.$router.push({
          path: '/plus/agent/index',
          query: {
            type: e.name
          }
        });
      }
      /*优惠券*/
      if(this.tab_type=='coupon'){
        this.$router.push({
          path: '/plus/coupon/index',
          query: {
            type: e.name
          }
        });
      }
      /*积分商城*/
      if(this.tab_type=='points'){
        this.$router.push({
          path: '/plus/points/index',
          query: {
            type: e.name
          }
        });
      }
      bus.$emit('activeValue', this.activeValue);
    },

    /*修改密码*/
    passwordFunc() {
      this.is_password = true;
    },

    routeFunc(){
      let self = this;
      /*删除用户菜单*/
      deleteSessionStorage('rolelist');
      /*删除用户权限*/
      deleteSessionStorage('authlist');
      const roles = Math.random();
      const accessRoutes = store.dispatch('user/generateRoutes', roles);
      self.$message({
        message: '恭喜你，重置成功',
        type: 'success'
      });
      location.reload();

    },

    /*关闭修改密码*/
    closeFunc() {
      this.is_password = false;
    }
  }
};
</script>

<style lang="scss">
.common-header .el-tabs__nav-wrap::after {
  display: none;
}
.common-header .el-tabs-container{margin-left: 20px; padding-left: 20px; border-left: 1px solid #EEEEEE;}
.common-header .el-tabs__header{  margin-bottom: 0;}
.header-city-selector {
  margin-right: 20px;
  cursor: pointer;
  color: #606266;
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 100%;
}
.header-city-selector:hover {
  color: #409EFF;
  background-color: #f5f5f5;
}
.header-city-selector i {
  margin-left: 5px;
  font-size: 12px;
}

/* 确保对话框不被遮挡 */
.el-dialog {
  z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Head.vue